import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(
        `https://app.metabolytics.ai/simulator-backend/healthcare/verify/${token}`
      )
      .then(() => {
        alert("Email Verified! Please log in.");
        navigate("/login");
      })
      .catch(() => alert("Invalid or expired token."));
  }, [token, navigate]);

  return <h2>Verifying Email...</h2>;
}

export default VerifyEmail;
